<template>
  <div class="Trainee-TS-modal-overlay">
    <div class="Trainee-TS-modal-dialog" @click.stop>
      <div class="Trainee-TS-modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <div class="Trainee-TS-modal-header">
          <h5 class="Trainee-TS-modal-title" style="padding-top: 15px; font-size: 26px;">
            Multi Revoke
            <span v-if="isInstSo">— Step 1 of 2: Instructor Sign Off</span>
            <span v-else>— Step 2 of 2: Trainee Sign Off</span>
          </h5>
        </div>
        <div class="tabs">
          <div class="artificial-fieldset">
            <div class="question">
              <table class="trainee-info-table">
                <tbody>
                  <tr>
                    <th>Please provide a reason to revoke the Sign Off(s)</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="trainee-answer-section">
              <div ref="editor" class="quill-editor"></div>
            </div>
          </div>
          <div class="button-container">
            <button class="ins-close-button" @click="close">Close</button>
            <div class="right">
              <!-- <button class="ins-save-button" @click="save(1)">Save</button> -->
              <button class="ins-submit-button" @click="submitAnswers">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
  name: 'revokeSignOffModal',
  props: {
    entries: {
      type: Array,
      required: true,
    },
    instructorId: {
      type: [String, Number],
      required: true,
    },
    task: {
      type: Object,
      required: true,
    },
    isInstSo: {
      type: [Boolean],
      required: true,
    },
  },
  data() {
    return {
      showRevokeModal: true,
      currentTab: 'new', // now represents the index of the selected revoke
      quill: null,
      revoked: false,
      revokes: [], // all fetched revokes
    };
  },
  watch: {
    showRevokeModal(newValue) {
      if (newValue && this.quill) {
        // Wait for the next tick to ensure the Quill editor is mounted and visible
        this.$nextTick(() => {
          this.quill.root.innerHTML = this.editableRevoke || '';
        });
      }
    },
    editableRevoke(newVal) {
      if (newVal !== this.quill.root.innerHTML) {
        this.quill.root.innerHTML = newVal;
      }
    },
    currentTab(newVal, oldVal) {
      if (newVal === 'troubleshoot' && oldVal === 'description') {
        this.initializeQuillEditor();
      }
    },
  },
  computed: {
    selectedRevoke() {
      if (typeof this.currentTab === 'number' && this.revokes[this.currentTab]) {
        return this.revokes[this.currentTab];
      }
      return {}; // default for 'new' or invalid index
    },
  },
  methods: {
    initializeQuillEditor() {
      if (!this.quill) {
        this.quill = new Quill(this.$refs.editor, {
          theme: 'snow',
          modules: {
            toolbar: [],
          },
        });
        this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar

        this.quill.on('text-change', () => {
          this.editableRevoke = this.quill.root.innerHTML;
        });

        this.quill.root.innerHTML = this.editableRevoke || '';
        this.adjustEditorHeight();
      }
    },
    formatDisplayDate(dateStr) {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return 'Invalid date';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    getEntrySignOffDate(entry) {
      const raw = this.isInstSo ? entry.ins_so : entry.completed;

      const iso = new Date(raw);
      if (!isNaN(iso.getTime())) {
        return this.formatDate(iso);
      }

      // "DD/MM/YYYY HH:mm:ss" format:
      const parsed = this.parseCustomDate(String(raw));
      if (parsed && !isNaN(parsed.getTime())) {
        return this.formatDate(parsed);
      }

      console.warn('Unrecognized completed date format:', raw);
      return this.formatDate(new Date());
    },
    parseCustomDate(dateStr) {
      // Expected format: "DD/MM/YYYY HH:mm:ss"
      const [datePart, timePart] = dateStr.split(' ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    loadData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      axios
        .get(`/api/revokes`, { headers })
        .then((response) => {
          // Filter revokes based on isInstSo prop
          this.revokes = response.data.filter(
            revoke => Number(revoke.is_instructor_signoff) === (this.isInstSo ? 1 : 0)
          );
          console.log('revokes', this.revokes);
        })
        .catch((error) => {
          console.error('Failed to load data', error);
        });
    },
    adjustEditorHeight() {
      const editorElement = this.$refs.editor.querySelector('.ql-editor');
      const toolbar = this.$refs.editor.querySelector('.ql-toolbar');
      const toolbarButtons = this.$refs.editor.querySelectorAll('.ql-toolbar .ql-formats');

      if (editorElement) {
        editorElement.style.height = '260px';
        editorElement.style.fontFamily = 'monospace';
      }
      if (toolbar) {
        toolbar.style.height = '40px';
        toolbar.style.minHeight = '30px';
      }
      if (toolbarButtons) {
        toolbarButtons.forEach((btnGroup) => {
          btnGroup.style.margin = '0 2px';
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async submitAnswers() {
      const plainText = this.quill.getText().trim();
      if (!plainText) {
        alert('Please enter a reason before submitting.');
        return;
      }

      const ok = window.confirm(
        `Once you submit, you cannot edit the reason for revoking.\n\n` +
        `This will revoke ${this.entries.length} signoff(s). Continue?`
      );
      if (!ok) return;

      try {
        const formattedRevoke = this.quill.root.innerHTML;

        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Build the batch payload in the format your controller expects
        const batchPayload = {
          revokes: this.entries.map((e) => ({
            instructor_id: Number(this.instructorId),
            logbookentry_id: Number(e.id ?? e.logbookentry_id), 
            revoke_reasoning: formattedRevoke || "Reason not provided",
            sign_off_date: this.getEntrySignOffDate(e),
            is_revoked: true,
            is_instructor_signoff: this.isInstSo,
          })),
        };

        // 1) Create revoke records in one request
        await axios.post('/api/revokes/batch', batchPayload, { headers });

        // 2) Tell parent we're done
        this.$emit('submitted');
      } catch (err) {
        console.error('Batch revoke failed:', err.response?.data || err);

        const validationErrors = err.response?.data?.errors;
        if (validationErrors) {
          const messages = Object.values(validationErrors).flat().join('\n');
          alert(`Failed to revoke one or more signoffs:\n\n${messages}`);
        } else {
          alert(err.response?.data?.message || 'Failed to revoke one or more signoffs.');
        }
      }
    },
    makeEditorReadOnly() {
      if (this.quill) {
        this.quill.enable(false); // This disables editing
        this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar
      }
      //this.$emit('close');
    },
  },
  mounted() {
    this.initializeQuillEditor();
    this.loadData();
    console.log('entries', this.entries);
    console.log('isInst', this.isInstSo);
  },
}
</script>

<style scoped>
table.trainee-info-table {
  font-family: Arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin-top: 10px;
}

.trainee-info-table th,
.trainee-info-table td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
  font-size: 14px;
}

.trainee-info-table td {
  font-weight: 100;
}

.trainee-info-table th {
  background-color: #f2f2f2;
}

.Trainee-TS-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.Trainee-TS-modal-body h2 {
  list-style-type: none;
  margin-top: 10px;
  padding: 0;
  margin-right: 1%;
  text-align: center;

}

.Trainee-TS-modal-body ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
  margin-left: 5%;
}

.Trainee-TS-modal-body p.heading {
  list-style-type: none;
  margin-top: 20px;
  text-align: left;
  margin-left: 1%;
}

.assessment-criteria-box {
  border: 1px solid #b1b1b1;
  /* You can adjust the border color and thickness */
  padding: 10px;
  /* Optional: Add padding for better appearance */
  margin: 10px 0;
  /* Optional: Add margin for spacing */
}


.Trainee-TS-modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1000px;
  width: 100%;
  margin: auto;
  padding: 0;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.Troubleshoot-modal-dialog {
  display: flex;
  flex-direction: row;
  /* Arrange children (questions and answers) in a row */
}

.Trainee-TS-modal-dialog {
  max-height: 90vh;
  overflow-y: auto;
}

.Troubleshoot-modal-body {
  display: flex;

}

.question-item {
  margin: 10px 0;
  text-align: left;
  font-weight: bold;
}

.Trainee-questions-container>ol>li>ul {
  list-style-type: disc;
  /* Adds a bullet point (dot) */
  padding-left: 40px;
  /* Indent subpoints further than the main list */
}

.Trainee-questions-container ul li {
  margin: 5px 0;
}

.Trainee-questions-container {
  text-align: left;
}

button {
  /* Adjust as needed */
  width: 100px;
  /* Adjust as needed */
  padding: 10px;
  /* Adjust as needed */
  background-color: #f2f2f2;
  /* Style as needed */
  border: none;
  /* Style as needed */
  cursor: pointer;
  /* Style as needed */
  /* Add more styling as needed */
}

.questions-list {
  text-align: left;
}

.Trainee-questions-container h6,
.Trainee-answers-container h6 {
  width: 100%;
  background-color: rgb(216, 216, 216);
  /* Light grey background */
  /* Border for the header */
  text-align: center;

}


.list-group-item {
  background-color: transparent;
  /* Remove default background */
}

.list-group-numbered {
  counter-reset: list-group-counter;
  text-align: left;
}

.list-group-numbered>.list-group-item:before {
  content: counter(list-group-counter) ". ";
  counter-increment: list-group-counter;
}

/* Style for the nested ul */
.Trainee-questions-container ul {
  list-style-type: none;
  /* Removes bullet points */
  padding-left: 20px;
  /* Indent subpoints */
}

.Trainee-answers-container {
  outline: none;
  z-index: 1000;
  width: 60%;
}

.right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  /* Adjust the gap between buttons */
}

.nav-link {
  cursor: pointer;
}

.artificial-fieldset {
  border: 1px solid #ddd;
  border-top: none;
  padding: 10px;
  position: relative;
}

.artificial-fieldset-legend {
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: #fff;
  padding: 0 10px;
  font-weight: bold;
}


.question {
  text-align: left;
  font-weight: bold;
}

.navigation-buttons {
  margin-top: 5px;
}

.nav-button {
  padding: 5px 15px;
  /* Adjust padding to change button size */
  margin: 0 5px;
  /* Space between buttons */

}


.ql-toolbar {
  height: 40px;
  min-height: 40px;
}


.ql-toolbar .ql-formats {
  margin: 0 2px;
}

.ql-container .ql-editor {
  height: 200px;
  min-height: 200px;
}

h4 {
  font-size: 1.5rem;
  margin-top: 30px;
  margin-bottom: 30px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 20px;
}

.ins-save-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #0157b3;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
}

.ins-save-button:hover {
  background-color: #0462c7;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(99, 15, 15);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 20px;
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.ins-close-button:hover {
  background-color: #545a5f;
}

.tabs {
  margin-left: 10px;
  margin-right: 10px;
}

.nav-link {
  color: black;
  background-color: #eeeeee;
}

.nav-link:hover {
  color: black;
  background-color: #dadada;
}

.nav-link.active {
  color: #007bff;
  background-color: #ffffff;
}

span {
  border: none;
  font-size: 26px !important;
}
</style>